import { useState, useRef } from 'react';

export const useIdeaDashboardState = () => {
  // Core idea state
  const [idea, setIdea] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [error, setError] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [icon, setIcon] = useState('😊');
  const [isPinned, setIsPinned] = useState(false);
  const [tags, setTags] = useState([]);
  const [breadcrumb, setBreadcrumb] = useState([]);

  // Component state
  const [components, setComponents] = useState([]);
  const [showComponentPicker, setShowComponentPicker] = useState(false);

  // UI state
  const [scale, setScale] = useState(3);
  const [effectiveScale, setEffectiveScale] = useState(3);
  const [animateComponents, setAnimateComponents] = useState(false);
  const [showRightSidebar, setShowRightSidebar] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Modal states
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showShareLayoutModal, setShowShareLayoutModal] = useState(false);
  const [showAccessibilityModal, setShowAccessibilityModal] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);

  // Edit modal states
  const [editModalTitle, setEditModalTitle] = useState('');
  const [editModalDescription, setEditModalDescription] = useState('');
  const [editModalIcon, setEditModalIcon] = useState('😊');
  const [editModalTags, setEditModalTags] = useState([]);
  const [editModalNewTag, setEditModalNewTag] = useState('');
  const [editModalStatus, setEditModalStatus] = useState('draft');
  const [showEditEmojiPicker, setShowEditEmojiPicker] = useState(false);
  const [editingTagIndex, setEditingTagIndex] = useState(null);
  const [editingTagValue, setEditingTagValue] = useState('');
  const [showTagsSection, setShowTagsSection] = useState(false);

  // Menu and options states
  const [showOptionsMenu, setShowOptionsMenu] = useState(false);
  const [menuButtonPosition, setMenuButtonPosition] = useState({ top: 0, right: 0 });

  // Search states
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredComponents, setFilteredComponents] = useState([]);

  // Drag and drop states
  const [isReordering, setIsReordering] = useState(false);
  const [draggedComponent, setDraggedComponent] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);

  // Resize states
  const [rightColumnWidth, setRightColumnWidth] = useState(() => {
    const saved = localStorage.getItem('rightColumnWidth');
    return saved ? parseInt(saved, 10) : 320;
  });
  const [isResizing, setIsResizing] = useState(false);

  // Toast and notification states
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  // Mobile chat states
  const [mobileChatOpen, setMobileChatOpen] = useState(false);
  const [mobileChatExpanded, setMobileChatExpanded] = useState(false);
  const [mobileChatMessage, setMobileChatMessage] = useState('');

  // Delete confirmation states
  const [deleteConfirmText, setDeleteConfirmText] = useState('');

  // Other states
  const [newTag, setNewTag] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  
  // Scroll behavior states
  const [showDescriptionSection, setShowDescriptionSection] = useState(true);

  // Refs
  const optionsMenuRef = useRef(null);
  const contentRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const chatRef = useRef(null);
  const menuButtonRef = useRef(null);

  return {
    // Core states
    idea, setIdea,
    currentUser, setCurrentUser,
    error, setError,
    title, setTitle,
    description, setDescription,
    icon, setIcon,
    isPinned, setIsPinned,
    tags, setTags,
    breadcrumb, setBreadcrumb,

    // Component states
    components, setComponents,
    showComponentPicker, setShowComponentPicker,

    // UI states
    scale, setScale,
    effectiveScale, setEffectiveScale,
    animateComponents, setAnimateComponents,
    showRightSidebar, setShowRightSidebar,
    mobileMenuOpen, setMobileMenuOpen,

    // Modal states
    showEditModal, setShowEditModal,
    showDeleteConfirm, setShowDeleteConfirm,
    showShareModal, setShowShareModal,
    showShareLayoutModal, setShowShareLayoutModal,
    showAccessibilityModal, setShowAccessibilityModal,
    showDuplicateModal, setShowDuplicateModal,

    // Edit modal states
    editModalTitle, setEditModalTitle,
    editModalDescription, setEditModalDescription,
    editModalIcon, setEditModalIcon,
    editModalTags, setEditModalTags,
    editModalNewTag, setEditModalNewTag,
    editModalStatus, setEditModalStatus,
    showEditEmojiPicker, setShowEditEmojiPicker,
    editingTagIndex, setEditingTagIndex,
    editingTagValue, setEditingTagValue,
    showTagsSection, setShowTagsSection,

    // Menu and options states
    showOptionsMenu, setShowOptionsMenu,
    menuButtonPosition, setMenuButtonPosition,

    // Search states
    showSearch, setShowSearch,
    searchQuery, setSearchQuery,
    filteredComponents, setFilteredComponents,

    // Drag and drop states
    isReordering, setIsReordering,
    draggedComponent, setDraggedComponent,
    dragOverIndex, setDragOverIndex,

    // Resize states
    rightColumnWidth, setRightColumnWidth,
    isResizing, setIsResizing,

    // Toast states
    showToast, setShowToast,
    toastMessage, setToastMessage,

    // Mobile chat states
    mobileChatOpen, setMobileChatOpen,
    mobileChatExpanded, setMobileChatExpanded,
    mobileChatMessage, setMobileChatMessage,

    // Delete confirmation states
    deleteConfirmText, setDeleteConfirmText,

    // Other states
    newTag, setNewTag,
    showEmojiPicker, setShowEmojiPicker,
    
    // Scroll behavior states
    showDescriptionSection, setShowDescriptionSection,

    // Refs
    optionsMenuRef,
    contentRef,
    mobileMenuRef,
    chatRef,
    menuButtonRef
  };
};
